import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { WidgetFC } from '@swf/core/types/Widget';
import { CommonStylesProvider, GameView } from '@swf/poker';

import AllIn from './components/AllIn/AllIn';
import GamesProvider from './components/GamesProvider/GamesProvider';
import SimpleView from './components/SimpleView/SimpleView';
import SpadeCashGames from './components/SpadeCashGames/SpadeCashGames';
import { pokerCashGamesWidgetModel } from './model';

const PokerCashGamesWidget: WidgetFC = () => {
  const { view } = useSelector(select.cms.getUrlParams);
  const pathname = useSelector(select.cms.getUrlPathname);
  const isCashGamesEmbedded = useFeature(FeatureFlag.SpadeReleaseEmbedCashGames);

  if (isCashGamesEmbedded) {
    return <SpadeCashGames />;
  }

  const Layout = (() => {
    if (pathname.includes('/all-in/')) {
      return <AllIn />;
    }

    switch (view) {
      case GameView.List:
        return <div data-testid="list-view">List View</div>;
      default:
        return <SimpleView />;
    }
  })();

  return (
    <GamesProvider>
      <CommonStylesProvider>{Layout}</CommonStylesProvider>
    </GamesProvider>
  );
};

PokerCashGamesWidget.model = pokerCashGamesWidgetModel;

export default PokerCashGamesWidget;
